import axios from "axios";
import app from "../_app";

const microcart = document.querySelector('.js-microcart');

const triggers = [...document.querySelectorAll('.js-microcart-trigger')];
const closeTriggers = [...document.querySelectorAll('.js-microcart-close')];
const count = document.querySelector('.js-microcart-count');

const loading = microcart.querySelector('.js-microcart-loading');
const products = microcart.querySelector('.js-microcart-products');
const empty = microcart.querySelector('.js-microcart-empty');

const setState = state => {
    if(state === 'loading') {
        loading.classList.remove('d-none');
        products.classList.add('d-none');
        empty.classList.add('d-none');
    } else if(state === 'products') {
        loading.classList.add('d-none');
        products.classList.remove('d-none');
        empty.classList.add('d-none');
    } else {
        loading.classList.add('d-none');
        products.classList.add('d-none');
        empty.classList.remove('d-none');
    }
}

const removeProduct = async e => {
    e.preventDefault();

    const removeTrigger = e.currentTarget;
    const id = removeTrigger.dataset.id;

    let response = await axios.post(`${window.Shopify.routes.root}cart/update.js`, {updates: {[id]: 0}});

    if(response.status === 200) {
        removeTrigger.parentNode.remove();

        if(response.data.items.length === 0) {
            setState('empty');
            count.removeAttribute('data-count');
        } else {
            count.setAttribute('data-count', response.data.items.length);
        }
    }
};

const createProduct = item => {
    const product = document.createElement('a');
    product.setAttribute('href', item.url);
    product.classList.add('microcart__product', 'img');

    const image = document.createElement('img');
    image.setAttribute('src', app.image(item.image, null, '340'));

    const remove = document.createElement('button');
    remove.setAttribute('type', 'button');
    remove.setAttribute('data-id', item.id);
    remove.addEventListener('click', removeProduct);
    remove.classList.add('microcart__product-remove');
    remove.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" width="14" height="14" viewBox="0 0 18 18"><path fill="#393536" d="m10.323 8.98 7.46-7.441a.896.896 0 0 0-.648-1.481.901.901 0 0 0-.62.215L9.054 7.714 1.593.264A.905.905 0 0 0 .05.901a.9.9 0 0 0 .265.638l7.47 7.44-7.47 7.442a.898.898 0 1 0 1.269 1.265l7.47-7.44 7.46 7.44A.902.902 0 0 0 18 17.04a.896.896 0 0 0-.215-.618L10.323 8.98Z"/></svg>`;

    const price = document.createElement('span');
    price.classList.add('microcart__product-price', 'price');
    price.innerText = `${item.quantity > 1 ? `${item.quantity}x` : ''} ${app.currency(item.price)}`;

    product.appendChild(image);
    product.appendChild(remove);
    product.appendChild(price);

    return product;
};

const placeProducts = data => {
    products.innerHTML = '';

    if(data.items.length === 0) {
        setState('empty');
    } else {
        data.items.reverse().map(item => {
            products.appendChild(createProduct(item));
        });

        setState('products');
    }
}

const fetchData = async () => {
    setState('loading')

    let response = await axios.get(`${window.Shopify.routes.root}cart.js`);

    if(response.status === 200) {
        count.setAttribute('data-count', response.data.items.length);

        placeProducts(response.data);
    }
};

export const openMicrocart = async data => {
    if(microcart) {
        app.lockBody();
        microcart.setAttribute('data-open', '');

        if(!data.target) {
            setState('loading');
            placeProducts(data);
        } else {
            await fetchData();
        }
    }
};

export const closeMicrocart = async () => {
    if(microcart) {
        microcart.removeAttribute('data-open');
        app.unlockBody();
    }
};

triggers.map(trigger => trigger.addEventListener('click', openMicrocart));
closeTriggers.map(closeTrigger => closeTrigger.addEventListener('click', closeMicrocart));

